import { Observable, Observer } from "rxjs";
import { HTTP_METHOD } from "../../constants/http";
import { AxiosSubscriber } from "../AxiosSubscriber";
import { IPlatformModel } from "../../models";

export class PlatformService {
  get url(): string {
    return "/Platforms";
  }

  public select = (): Observable<IPlatformModel[]> =>
    new Observable(
      (observer: Observer<IPlatformModel[]>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.GET,
          url: `${this.url}/Select`,
        })
    );
}
